import React from "react";
import "./support.scss";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";

const Welcome = () => {
  return (
    <>
      <div className="maincontent">
        <div className="innercontent">
            <div>
        <Element name="overview" >
          <h1 className="mainhead">Welcome to tomi Help Center</h1>
          <h4 className="midhead">Overview</h4>
          <p className="mainpara">
            Welcome to the tomi, your gateway to a new era of digital
            interaction, combining social networking with secure cryptocurrency
            transactions. This section provides an overview of essential topics
            for first-time users.
          </p>
          <p className="mainpara">
            To get started, download and install the app from Google Play or
            Apple App Store. Then click on the links below to get step-by-step
            instructions on the selected topic.
          </p>
          </Element>
          <Element name="Quick links">
          <h4 className="midhead">Quick links</h4>
          <NavLink
                      exact
                      to="/support/whatwedo" className="maininnerlink">
            What we do
          </NavLink>
          {/* <NavLink
                      exact
                      to="/support/ourfeatures" className="maininnerlink">
            Our Features
          </NavLink> */}
          </Element>
          <Element name="Get started">
          <h4 className="midhead">Get Started</h4>
          <p className="mainpara">
            We've put together some helpful guides for you to get setup with our
            product quickly and easily.
          </p>
          <NavLink
                      exact
                      to="/support/gettingstarted" className="maininnerlink">
            Getting Started
          </NavLink>
          <NavLink
                      exact
                      to="/support/chatandpayments" className="maininnerlink">
          Chat and Payment
          </NavLink>
          {/* <a href="" className="maininnerlink">
            Broken link
          </a> */}
          </Element>
          </div>
          <div className="bottom-btns">
            <NavLink
                      exact
                      to="/support/whatwedo" className="innerbtn">
              <div className="leftbtn">
                <p className="innerbtnpara">Next - Overview</p>
                <p className="innerbtnhead">What we do</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink>
          </div>
        </div>
        <div className="right-sidebar">
          <div className="main-heading">
            <span>On this page</span>
          </div>
          <div className="rightlinks">
            <Link
              to="overview"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Overview
            </Link>
            <Link
              to="Quick links"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Quick links
            </Link>
            <Link
              to="Get started"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Get started
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Welcome;
